<template>
  <div>
    <core-grid ref="grid" :schema="schema" server-side :edit-option="false" :add-option="false" :onRead="onRead">
      <template v-slot:toolbar>
        <core-grid-button color="primary" @click="editar($event)" text="Novo" icon="fas fa-plus"> </core-grid-button>
      </template>
      <template v-slot:[`item.nomeCliente`]="{item}">
        <div class="d-flex flex-column font-weight-medium my-4">
          <span>
            {{ item.nomeCliente}}
          </span>
          <span class="text-caption">
            {{ item.documentoCliente}}
          </span>
        </div>
      </template>
      <template v-slot:[`item.dtExpiracao`]="{item}">
        <div class="d-flex flex-column font-weight-medium my-4">
          <span :class="simulacaoExpirada(item) ? 'red--text' : 'black--text'">
            {{ $api.UI.Format.Date(item.dtExpiracao) }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.simulacao`]="{item}">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn elevation="0" v-on="on" icon @click.prevent="editar($event, item)">
              <v-icon color="black" small>fa-pencil-alt</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
      </template>
    </core-grid>
    <SimulacaoVisualizar ref="visualizar" />
  </div>
</template>

<script>
export default {
  components: {
    SimulacaoVisualizar: () => import('./SimulacaoVisualizar'),
  },
  data () {
    return {
      schema: [
        { text: 'Data Inclusão', value: 'dtInclusao', format: 'date' },
        { text: 'Vendedor', value: 'vendedor' },
        { text: 'Cliente', value: 'nomeCliente' },
        { text: 'Data Expiração', value: 'dtExpiracao', format: 'date' },
        { value: 'simulacao', align: 'center', width: '25' }
      ],
      datepicker: new Date(),
      model: {}
    }
  },
  methods: {
    simulacaoExpirada (item) {
      var dataAtual = new Date()
      return this.$api.UI.Date.DaysBetween(dataAtual, item.dtExpiracao) < 0
    },
    onRead (options, search) {
      const th = this
      const dto = Object.assign({ parameters: [{ name: 'search', value: search }] }, options)
      th.$api.Simulacao.GetAll(dto).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          options.success(response.data, response.count)
        }
      })
    },
    editar (e, current) {
      e.preventDefault()
      const th = this
      if (current) {
        th.$router.push({ path: `/simulacao-edit?codigoSimulacao=${current.codigo}`, })
      } else {
        th.$router.push('/simulacao-edit')
      }
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    excluir (item) {
      const th = this
      th.$api.Simulacao.Delete(item.codigo).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.refresh()
        }
      })
    }
  }
}
</script>
